const ArrowUpRight03Icon = /*#__PURE__*/ [
  ["path", { d: "M16.5 7.5L6 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 6.18791C8 6.18791 16.0479 5.50949 17.2692 6.73079C18.4906 7.95209 17.812 16 17.812 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { ArrowUpRight03Icon as default };
//# sourceMappingURL=ArrowUpRight03Icon.js.map
